import Vue from 'vue';
import Vuex from 'vuex';
import axios from '../utils/axios-general';
import * as CryptoJS from 'crypto-js';
import { setTimeout } from 'timers';
import EventBus from '../utils/event-bus';
import createPersistedState from 'vuex-persistedstate';
import { Config } from '../config';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    user: {
      token: 123,
      id: null,
      user: '',
      role: '',
      isLogged: false,
      language: 'es_ES'
    }
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage
    })
  ],
  mutations: {
    authUser (state, userData) {
      if (!state.user) state.user = {};
      state.user.token = userData.token;
      state.user.id = userData.id;
      state.user.isLogged = userData.isLogged;
      state.user.language = userData.language;
    },
    storeUser (state, data) {
      state.user.user = data.user;
      state.user.role = data.role;
      state.user.isLogged = true;
      state.user.language = data.language;
    },
    clearData (state) {
      state.user.token = null;
      state.user.id = null;
      state.user.user = null;
      state.user.isLogged = false;
      state.user.language = 'es_ES';
    },
    storeUseFromRenew (state, data) {
      state.user.user = data.user;
    }
  },
  actions: {
    renewToken  ({ commit, state, dispatch }) {
      axios.defaults.headers.common['x-access-token'] = state.user.token;
      axios.get('renew')
        .then(res => {
          if (!window.renew) {
            window.renew = setInterval(() => {
              dispatch('renewToken');
            }, 1000 * 60 * 15);
          }
        })
        .catch(() => dispatch('logout'));
    },
    setRenewTimer ({ commit, state, dispatch }, renewTime) {
      setTimeout(() => {
        axios.defaults.headers.common['x-access-token'] = state.user.token;
        axios.get('renew')
          .then(res => {
            dispatch('setRenewTimer', (res.data.expiresIn) / 2);
          })
          .catch(() => dispatch('logout'));
      }, renewTime * 1000);
    },
    setLogoutTimer ({ commit }, expirationTime) {
      setTimeout(() => {
        commit('clearData');
      }, expirationTime * 1000);
    },
    logout ({ commit }) {
      commit('clearData');
      clearInterval(window.renew);
      window.renew = false;
      window.location.replace(window.location.protocol + '//' + window.location.host + '/login');
      // router.replace('login');
    },
    signup ({ commit }, authData) {
    },
    login ({ commit, dispatch }, authData) {
      const hash = CryptoJS.SHA256(authData.password);
      const pwd = hash.toString(CryptoJS.enc.Base64);
      axios.post('login', {
        login: authData.login,
        password: pwd
      })
        .then(res => {
          commit('authUser', {
            token: res.data.token,
            id: res.data._id,
            isLogged: true,
            language: authData.language
          });
          commit('storeUser', {
            user: res.data.login,
            role: res.data.role,
            language: authData.language
          });
          dispatch('setRenewTimer', (res.data.expiresIn) / 2);
          dispatch('renewToken');
          EventBus.$emit('loginOk');
        }).catch(
          error => {
            EventBus.$emit('loginError', { error: error });
          }
        );
    },
    renew ({ commit }, authData) {
      commit('storeUseFromRenew', {
        user: authData.data.login
      });
    }
  },
  getters: {
    user (state) {
      return state.user.user ? state.user.user : '';
    },
    isAuthenticated (state) {
      return state.user.isLogged === true;
    },
    token (state) {
      return state.user.token;
    },
    isAdmin (state) {
      if (state.user.role) {
        if (state.user.role.indexOf(0) !== -1) {
          return true;
        }
      }
      return false;
    },
    isRole: state => (roleid) => {
      if (state.user.role) {
        if (state.user.role.indexOf(roleid) !== -1) {
          return true;
        }
      }
      return false;
    },
    getUserRole (state) {
      return state.user.user ? state.user.user.role : -1;
    },
    getid (state) {
      return state.user.user ? state.user.user._id : '';
    }
  }
});

export default store;
